import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { IBeneficiary } from "src/app/modules/shared/models/policy.model"
import { individual_form_keys, individual_form_template, individual_form_validators, legal_person_form_keys, legal_person_form_template, legal_person_form_validators, relationshipWithSubscriberOptions } from "../beneficiary-form/beneficiary-form.constants"
import moment = require("moment")

export const claim_notification_form_template = {
    deceaseDate: null,
    deceaseCause: null,
    declarantName: null,
    declarantSurname: null
}

export const claim_notification_form_validators = {
    deceaseDate: [Validators.required],
    deceaseCause: [Validators.required],
    declarantName: [Validators.required],
    declarantSurname: [Validators.required]
}

export const claim_notification_form_keys: IFormKey[] = [
    {
        id: 'decease-line-field',
        label: 'Dati relativi al decesso',
        controlName: 'deceaseLine',
        type: 'NEW_LINE',
        css: 'col-12'
    },
    {
        id: 'decease-date-field',
        label: 'Data del decesso',
        controlName: 'deceaseDate',
        css: 'col-3',
        maxDate: moment(),
        type: 'DATEPICKER'
    },
    {
        id: 'decease-cause-field',
        label: 'Causa del decesso',
        controlName: 'deceaseCause',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'decease-line-field',
        label: 'Dati relativi al dichiarante',
        controlName: 'declarantLine',
        type: 'NEW_LINE',
        css: 'col-12'
    },
    {
        id: 'declarant-name-field',
        label: 'Nome del dichiarante',
        controlName: 'declarantName',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'declarant-surname-field',
        label: 'Cognome del dichiarante',
        controlName: 'declarantSurname',
        css: 'col-3',
        type: 'INPUT'
    }
]

export const SIMOR_individual_form_template = {
    ...individual_form_template,
    iban: null
}

export const SIMOR_individual_form_validators = {
    ...individual_form_validators,
    iban: [Validators.required]
}

export const SIMOR_individual_form_keys: IFormKey[] = [
    ...individual_form_keys.slice(0, individual_form_keys.length - 1),
    {
        id: 'individual-iban-field',
        label: 'IBAN',
        controlName: 'iban',
        css: 'col-4',
        type: 'INPUT'
    },
    ...individual_form_keys.slice(individual_form_keys.length - 1)
];

export const SIMOR_legal_person_form_template = {
    ...legal_person_form_template,
    iban: null
}

export const SIMOR_legal_person_form_validators = {
    ...legal_person_form_validators,
    iban: [Validators.required]
}

export const SIMOR_legal_person_form_keys: IFormKey[] = [
    ...legal_person_form_keys.slice(0, legal_person_form_keys.length - 1),
    {
        id: 'legal-person-iban-field',
        label: 'IBAN',
        controlName: 'iban',
        css: 'col-4',
        type: 'INPUT'
    },
    ...legal_person_form_keys.slice(legal_person_form_keys.length - 1)
];

export const SIMOR_subject_PF_fields: string[] = ['beneficiaryTypeDesc', 'taxCode', 'birthDate', 'name', 'surname', 'citizenship', 'sex', 'birthNewLine', 'birthPlace', 'birthProvince', 'birthCountry', 'residenceNewLine', 'residenceCountry', 'residencePlace', 'residenceProvince', 'residencePostalCode', 'residenceToponym', 'residenceAddress', 'residenceAddressNumber', 'quote', 'relationshipWithSubscriber', 'iban'];
export const SIMOR_subject_PG_fields: string[] = ['beneficiaryTypeDesc', 'companyName', 'vatCode', 'quote', 'relationshipWithSubscriber', 'shareCapital', 'birthDate', 'residenceNewLine', 'residenceCountry', 'residencePlace', 'residenceProvince', 'residencePostalCode', 'residenceToponym', 'residenceAddress', 'residenceAddressNumber', 'iban'];

export const search_subject_form_template = {
    ndg: null
}

export const search_subject_form_validators = {
    ndg: [Validators.required]
}

export const search_subject_form_keys: IFormKey[] = [
    {
        id: 'ndg-field',
        label: 'NDG Beneficiario',
        controlName: 'ndg',
        css: 'col-4',
        type: 'INPUT'
    }
]

export const additional_subject_info_form_template = {
    iban: null,
    relationshipWithSubscriber: null,
    quote: null
}

export const additional_subject_info_form_validators = {
    iban: [Validators.required, Validators.pattern(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/)],
    relationshipWithSubscriber: [Validators.required],
    quote: [Validators.required, Validators.pattern(/^(100(?:\,0+)?|(?:[1-9][0-9]?|100)(?:\,\d+)?|\d(?:\,\d+))$/)]
}

export const additional_subject_info_form_keys: IFormKey[] = [
    {
        id: 'additional-form-iban-field',
        label: 'IBAN',
        controlName: 'iban',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'relationshipWithSubscriber-field',
        label: 'Relazione beneficiario-contraente',
        controlName: 'relationshipWithSubscriber',
        css: 'col-4',
        type: 'SELECT',
        options: relationshipWithSubscriberOptions
    },
    {
        id: 'quote-field',
        label: 'Quota Beneficiario',
        controlName: 'quote',
        css: 'col-4',
        type: 'INPUT'
    }
]

export const beneficiary_fields = {
    'taxCode': 'ns2:codiceFiscale',
    'birthDate': 'ns2:dataNascita',
    'name': 'ns2:nome',
    'surname': 'ns2:cognome',
    'citizenship': 'ns2:codicePrimaCittadinanza',
    'sex': 'ns2:sesso',
    'residencePlace': 'ns2:comuneSedeLegale',
    'residenceProvince': 'ns2:provinciaSedeLegale',
    'residencePostalCode': 'ns2:capSedeLegale',
    'vatCode': 'ns2:partitaIva'
}

export interface IComunicazioneSinistroRequest {
    policyNumber: string;
    subjects: any[];
    dataMorte: string;
    motivoSinistro: string;
    payments: any[];
    denunciante: string; // cognome nome
    beneficiaries: IBeneficiary[];
    liquidationSubjects?: Record<string, any>; // Only mappedOutcome values
}
